import React from "react";
import { Save } from "lucide-react";

export default function AdminContentSection({ form, set, save, PdfUploader }) {
  return (
    <>
      <div className="space-y-4 max-w-2xl mt-8">
        <h2 className="font-outfit font-bold text-[#0B1D3A]/70 mt-4">Área de Professores e Encarregados (login)</h2>
        <div className="rounded-2xl bg-white p-5 border border-[#0B1D3A]/5 space-y-3" data-testid="account-login-settings">
          <p className="text-xs text-[#0B1D3A]/50">Controle quais métodos de início de sessão aparecem na área de conta (/account) e no formulário de inscrição.</p>
          <label className="flex items-center gap-2 text-sm font-medium">
            <input type="checkbox" checked={form.account_email_enabled !== false}
              onChange={(e) => set("account_email_enabled", e.target.checked)}
              className="h-4 w-4 accent-[#005F73]" data-testid="account-email-enabled" />
            Entrar com email e palavra-passe
          </label>
          <label className="flex items-center gap-2 text-sm font-medium">
            <input type="checkbox" checked={form.account_google_enabled !== false}
              onChange={(e) => set("account_google_enabled", e.target.checked)}
              className="h-4 w-4 accent-[#005F73]" data-testid="account-google-enabled" />
            Entrar com Google
          </label>
          <label className="flex items-center gap-2 text-sm font-medium">
            <input type="checkbox" checked={form.account_facebook_enabled !== false}
              onChange={(e) => set("account_facebook_enabled", e.target.checked)}
              className="h-4 w-4 accent-[#005F73]" data-testid="account-facebook-enabled" />
            Entrar com Facebook / Instagram
          </label>
          <p className="text-xs text-[#0B1D3A]/40">Nota: se desativar todos, o início de sessão fica indisponível, mas continua a ser possível inscrever turmas sem conta.</p>
        </div>

        <h2 className="font-outfit font-bold text-[#0B1D3A]/70 mt-4">Autorização Parental (disponível para download — já não é anexada ao email)</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <PdfUploader label="PDF Autorização Parental (PT)" field="parental_auth_pdf_pt" testId="parental-pdf-pt" />
          <PdfUploader label="Parental Authorization PDF (EN)" field="parental_auth_pdf_en" testId="parental-pdf-en" />
        </div>


        <button onClick={save} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-[#0B1D3A] text-white font-bold">
          <Save size={16}/> Guardar
        </button>
      </div>
    </>
  );
}
